import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {Configuration} from 'src/app/models/configurations/configuration';
import {Constants} from 'src/app/models/constants';
import {FormUtilService} from 'src/app/services/util/form-util.service';
import {SidenavService} from 'src/app/services/util/sidenav.service';

@Component({
    selector: 'app-report-issue',
    templateUrl: './report-issue.component.html',
    styleUrls: ['./report-issue.component.scss'],
    standalone: false
})
export class ReportIssueComponent  implements OnInit {
private destroyRef = inject(DestroyRef);

  @Input() title: string;
  @Input() subtitle: string;
  @Input() report: any;
  @Input() configurations: Configuration[];

  reportIssueForm: UntypedFormGroup;

  Constants = Constants;

  constructor(private formBuilder: UntypedFormBuilder, public sidenavService: SidenavService) {
    
  }

  ngOnInit(): void {
    this.createForm();
  }

  /**
   * Validates the form and if the validation results successful, the
   * sidenav service is closed and we get the report object
   */
  reportIssue() {
    if (!FormUtilService.validateForm(this.reportIssueForm)) {
      return;
    }
    const report = this.reportIssueForm.getRawValue();
    this.sidenavService.closeRightSidenav(report);
  }

  /**
   * Prepares the report issue form
   */
  private createForm() {
    this.reportIssueForm = this.formBuilder.group({
      solutionId: [this.report.serviceId],
      blueprintId: [this.report.blueprintId],
      instanceId: [this.report.instanceId],
      description: [this.report.description, Validators.required],
    });
  }
}
